import React, { Component } from 'react';
import { graphql } from 'gatsby';

import classes from './pricing.module.css';

class PriceImageView extends Component {
  state = {
    ...this.props.data.dataJson
  };

  render() {
    return (
      <div className={classes.PriceList}>
        {this.state.links.map(link => {
          return (
            <img
              src={link.link}
              key={link.id}
              alt={`${this.state.make} pricelist`}
            />
          );
        })}
      </div>
    );
  }
}

export default PriceImageView;

export const query = graphql`
  query($slug: String!) {
    dataJson(slug: { eq: $slug }) {
      make
      slug
      links {
        id
        link
      }
    }
  }
`;
